import React from 'react';
import { useReducedMotion } from 'framer-motion';
import { EASE, motionTag, useRevealInView } from './Reveal';

const makeItem = (y = 18) => ({
  hidden: { opacity: 0, y },
  show: { opacity: 1, y: 0, transition: { duration: 0.55, ease: EASE } },
});
const defaultItem = makeItem();

/**
 * Staggered reveal container; direct animated children should be <StaggerItem>.
 * `<Stagger className stagger={0.06}>`. Pass `animateOnMount` to animate immediately
 * instead of when scrolled into view. Uses the same never-stay-hidden trigger as <Reveal>.
 */
export function Stagger({ as = 'div', className = '', stagger = 0.06, delay = 0, once = true, amount = 0.15, animateOnMount = false, children, ...rest }) {
  const Tag = motionTag(as);
  const reduce = useReducedMotion();
  const [ref, inView] = useRevealInView({ once, amount });
  const variants = { hidden: {}, show: { transition: { staggerChildren: stagger, delayChildren: delay } } };
  const shown = reduce || animateOnMount || inView;
  return (
    <Tag ref={ref} className={className} variants={variants} initial={reduce ? false : 'hidden'} animate={shown ? 'show' : 'hidden'} {...rest}>
      {children}
    </Tag>
  );
}

export function StaggerItem({ as = 'div', className = '', y, children, ...rest }) {
  const Tag = motionTag(as);
  return (
    <Tag className={className} variants={typeof y === 'number' ? makeItem(y) : defaultItem} {...rest}>
      {children}
    </Tag>
  );
}

export default Stagger;
